import { useQuery } from "@tanstack/react-query";
import { Check, CreditCard, Lock } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export function usePaymentMethods() {
  return useQuery({
    queryKey: ["payment-methods"],
    queryFn: async () => {
      const r = await api.get("/payments/methods");
      return Array.isArray(r.data) ? r.data : [];
    },
  });
}

const COPY = {
  monetico: { title: "Carte bancaire", sub: "Paiement sécurisé par CIC Paiement — CB, Visa, Mastercard" },
  paypal: { title: "PayPal", sub: "Payer avec PayPal — ou en 4 fois sans frais" },
  stripe: { title: "Carte bancaire", sub: "Paiement sécurisé Stripe" },
  reservation: { title: "Virement bancaire", sub: "Coordonnées bancaires affichées après validation et envoyées par email" },
};

function PayPalMark() {
  return <span className="font-display text-sm font-bold italic tracking-tight"><span className="text-[#5b8fd6]">Pay</span><span className="text-[#8fc1ff]">Pal</span></span>;
}

export function PaymentMethods({ methods, value, onChange }) {
  const { t } = useLang();
  return (
    <div data-testid="payment-methods" role="radiogroup" aria-label={t("Moyen de paiement")} className="space-y-2">
      {methods.map((m) => {
        const on = value === m.id;
        const c = COPY[m.id] || { title: m.label, sub: "" };
        return (
          <button
            key={m.id}
            type="button"
            role="radio"
            aria-checked={on}
            disabled={!m.available}
            data-testid={`payment-option-${m.id}`}
            onClick={() => onChange(m.id)}
            className={`flex w-full items-center gap-3 rounded-sm border px-4 py-4 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${on ? "border-[var(--gold)] bg-[rgba(217,180,106,0.08)]" : "border-[var(--line)] hover:border-[var(--gold)]/50"}`}
          >
            <span className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${on ? "border-[var(--gold)] bg-[var(--gold)]" : "border-[var(--muted)]"}`}>{on && <Check className="h-3 w-3 text-[var(--ink)]" />}</span>
            <span className="flex-1">
              <span className="block text-sm">{t(c.title)}</span>
              <span className="text-xs text-[var(--muted)]">{m.available ? t(c.sub) : t("Bientôt disponible")}</span>
            </span>
            {m.id === "paypal" ? <PayPalMark /> : <CreditCard className="h-5 w-5 text-[var(--gold-soft)]" />}
          </button>
        );
      })}
      <p className="flex items-center gap-2 pt-1 text-xs text-[var(--muted)]"><Lock className="h-3 w-3" /> {t("Vos données bancaires ne transitent jamais par notre site.")}</p>
    </div>
  );
}
